const DropdownDivider = () => {
  return <div className="my-1 border-t border-gray-200" />
}

export default DropdownDivider

